module.exports = __webpack_public_path__ + "static/media/ios-flash.ee8ef10f.svg";